import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/product_categories/CUIDADO PERSONAL.png")